import React from "react";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UsedInLink from "../UsedInLink";

export default function DataCategory() {
  const navigate = useNavigate();
  const params = useParams();

  const { category, projectID, type } = params;

  const location = useLocation();
  const handleClose = () => {
    navigate(location.state?.nextPage || `/library/logic/builder/${projectID}`);
  };

  return (
    <Modal size="xl" centered show={category} onHide={handleClose} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="icon fa fa-edit" />
          {type[0].toUpperCase()}
          {type.slice(1)} category - {category}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* UsedInLink expects a UUID */}
        <UsedInLink arg={{ UUID: category }} />
      </Modal.Body>
    </Modal>
  );
}
